 
// Mega Menu JS Start
// Dawn hover menu (desktop only)
document.querySelectorAll(".header__inline-menu details").forEach((item) => {
    let timeout;
 
    item.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      item.setAttribute("open", true);
    });
 
    item.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 200); // little delay here to keep the menu alive during the choice :)
    });
  });


// Mega Menu JS ENd

// Subcription Tab Open JS
  jQuery(document).ready(function ($) {
    $('.subscription-accrodion-info details').attr('open', true);
  });
// Subcription Tab Open End



// Banner Logo Slider JS Start
jQuery(document).ready(function($) {
  $('.banner-logo-slider,.client-row.ltr .client-track').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    variableWidth: true
  });
});

// Banner Logo Slider JS End
// Clients Logo Slider JS Start
jQuery(document).ready(function($) {
  $('.client-row.rtl .client-track').slick({
        autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    arrows: false,
    swipe: false,
    slidesToShow: 5,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    variableWidth: true,
    rtl: true
  });
});
// Clients Logo Slider JS End
// Why Choose US Slider JS Start
 jQuery(document).ready(function($){

    var $slider = $('.why-cards-slider');
    var totalSlides = $slider.children().length;

    // Default values
    var desktopShow = 4;
    var tabletShow = 2;
    var mobileShow = 1;

    function updateArrows() {
        var width = $(window).width();
        var slidesToShow;

        if (width <= 599) {
            slidesToShow = mobileShow;
        } else if (width <= 990) {
            slidesToShow = tabletShow;
        } else {
            slidesToShow = desktopShow;
        }

        // Hide/Show custom arrows
        if (totalSlides > slidesToShow) {
            $('.why-cards-arrows').show();
        } else {
            $('.why-cards-arrows').hide();
        }
    }

    // Initial call
    updateArrows();

    // Recheck on resize
    $(window).on("resize", function() {
        updateArrows();
    });


    // Initialize Slick
    $slider.slick({
        slidesToShow: desktopShow,
        slidesToScroll: 1,
        infinite: totalSlides > desktopShow,
        arrows: true,
        prevArrow: $('.why-cards-prev'),
        nextArrow: $('.why-cards-next'),
        dots: false,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: tabletShow,
                    infinite: totalSlides > tabletShow,
                    arrows: totalSlides > tabletShow
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: mobileShow,
                    infinite: totalSlides > mobileShow,
                    arrows: totalSlides > mobileShow
                }
            }
        ]
    });

});

// Why Choose US Slider JS End
// Counter Script Start

// document.addEventListener("DOMContentLoaded", () => {
//   const counters = document.querySelectorAll(".counter-number");
//   let started = false; // prevent running twice

//   const startCounting = () => {
//     counters.forEach(counter => {
//       const target = parseInt(counter.dataset.target, 10);
//       let start = 0;
//       const duration = 1200;
//       const startTime = performance.now();

//       function update(now) {
//         const progress = Math.min((now - startTime) / duration, 1);
//         const value = Math.floor(progress * target);
//         counter.textContent = value;

//         if (progress < 1) requestAnimationFrame(update);
//       }

//       requestAnimationFrame(update);
//     });
//   };

//   // Observe section
//   const section = document.querySelector(".counter-section");

//   const observer = new IntersectionObserver(
//     (entries) => {
//       if (entries[0].isIntersecting && !started) {
//         started = true;
//         startCounting();
//       }
//     },
//     { threshold: 0.3 } // fires when 30% of section in view
//   );

//   observer.observe(section);
// });

document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".counter-number");
  const section = document.querySelector(".counter-section");

  // ✅ Stop if section or counters don't exist
  if (!section || !counters.length) return;

  let started = false; // prevent running twice

  const startCounting = () => {
    counters.forEach(counter => {
      const target = parseInt(counter.dataset.target, 10) || 0;
      const duration = 1200;
      const startTime = performance.now();

      function update(now) {
        const progress = Math.min((now - startTime) / duration, 1);
        const value = Math.floor(progress * target);
        counter.textContent = value;

        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && !started) {
        started = true;
        startCounting();
        observer.disconnect(); 
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(section);
});


// Counter Script End

// Rreview Slider JS Start
jQuery(document).ready(function($){

    $('.s-review-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: $('.custom-prev'),
        nextArrow: $('.custom-next'),
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 600,
                settings: {slidesToShow: 2 }
            }
        ]
    });

});
// Review Slider Js End

// Pricing Page Accordion JS Start
$(document).ready(function () {

  // --- OPEN FIRST ACCORDION ON LOAD ---
  let first = $(".see-feature-table-area .accordion-step").first();
  first.addClass("active");
  first.find(".accordion-title-row").addClass("active");
  first.find(".accordion-body-row").show();

  // --- CLICK HANDLER ---
  $(".see-feature-table-area .accordion-title-row h4").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    let step = $(this).closest(".accordion-step");
    let body = step.find(".accordion-body-row");

    // --- IF CLICKING THE OPEN ONE → CLOSE IT ---
    if (step.hasClass("active")) {
      step.removeClass("active");
      step.find(".accordion-title-row").removeClass("active");
      body.slideUp(300);
      return;
    }

    // --- CLOSE ALL OTHER ACCORDIONS ---
    $(".accordion-step.active")
      .removeClass("active")
      .find(".accordion-body-row")
      .slideUp(300);

    $(".accordion-title-row.active").removeClass("active");

    // --- OPEN CLICKED ACCORDION ---
    step.addClass("active");
    step.find(".accordion-title-row").addClass("active");
    body.stop(true, true).slideDown(300);

  });

});


// Pricing Page Accordion Js End

// Blog  JS Start

// Search JS Start
// document.getElementById("blogSearchInput").addEventListener("input", function () {
  
//   let searchValue = this.value.toLowerCase().trim().replace(/\s+/g, "");

//   let articles = document.querySelectorAll(".blog-articles__article");

//   articles.forEach(function (article) {

//     let titleEl = article.querySelector(".card__heading, .article-card__title, h2, h3");
//     let tags = article.querySelectorAll(".article-category, .tag");

//     let text = "";

//     if (titleEl) {
//       text += titleEl.textContent.toLowerCase().replace(/\s+/g, "");
//     }

//     tags.forEach(tag => {
//       text += " " + tag.textContent.toLowerCase().replace(/\s+/g, "");
//     });

//     // Partial matching
//     if (text.includes(searchValue)) {
//       article.style.display = "block";
//     } else {
//       article.style.display = "none";
//     }

//   });

// });

// Search JS Start
document.addEventListener("DOMContentLoaded", function () {

  const searchInput = document.getElementById("blogSearchInput");
  if (!searchInput) return; // ✅ stop if input doesn't exist

  const articles = document.querySelectorAll(".blog-articles__article");
  if (!articles.length) return; // ✅ stop if no articles found

  searchInput.addEventListener("input", function () {

    const searchValue = this.value
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "");

    articles.forEach(function (article) {

      if (!article) return;

      const titleEl = article.querySelector(
        ".card__heading, .article-card__title, h2, h3"
      );
      const tags = article.querySelectorAll(".article-category, .tag");

      let text = "";

      if (titleEl && titleEl.textContent) {
        text += titleEl.textContent
          .toLowerCase()
          .replace(/\s+/g, "");
      }

      if (tags.length) {
        tags.forEach(tag => {
          if (tag && tag.textContent) {
            text += " " + tag.textContent
              .toLowerCase()
              .replace(/\s+/g, "");
          }
        });
      }

      article.style.display =
        !searchValue || text.includes(searchValue)
          ? "block"
          : "none";
    });

  });
});

// Search JS End


// Category active
document.addEventListener("DOMContentLoaded", function () {
  let currentUrl = window.location.href.toLowerCase();

  document.querySelectorAll(".blog-tags .tag-btn").forEach(btn => {
    let btnUrl = btn.getAttribute("href").toLowerCase();

    // Match the URL
    if (currentUrl.includes(btnUrl.replace(window.location.origin.toLowerCase(), ""))) {
      document.querySelector(".blog-tags .tag-btn.active")?.classList.remove("active");
      btn.classList.add("active");
    }
  });
});


// Blog JS End

 
